module.exports = __webpack_public_path__ + "../resources/images/balloon-f2ce1273a44d18510dc7894b408cfd3c.svg";